(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chibimall-health-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('chibimall-banner-carousel')) {
    customElements.define('chibimall-banner-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const on = (target, type, handler) => target.addEventListener(type, handler, { signal: this.abort.signal });
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.index = 0;
        if (this.slides.length < 2) return;
        this.querySelector('.ch-carousel__controls').hidden = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        on(this, 'click', event => {
          if (this.swiped && performance.now() - this.swiped < 500 && event.target.closest('.ch-carousel__viewport')) { event.preventDefault(); this.swiped = false; return; }
          const dot = event.target.closest('[data-slide-to]');
          if (dot) { this.show(Number(dot.dataset.slideTo)); }
          if (event.target.closest('[data-toggle]')) { this.paused = !this.paused; this.sync(); }
        });
        on(this, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); this.paused = true;
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.dots[this.index].focus();
        });
        on(this, 'focusin', event => { if (event.target === this.toggle || !event.target.matches(':focus-visible')) return; this.paused = true; this.sync(); });
        on(document, 'visibilitychange', () => this.sync());
        on(this.motion, 'change', () => { if (this.motion.matches) this.paused = true; this.sync(); });
        const viewport = this.querySelector('.ch-carousel__viewport');
        on(viewport, 'pointerdown', event => { this.swiped = false; this.start = { x: event.clientX, y: event.clientY }; clearInterval(this.timer); });
        on(viewport, 'pointerup', event => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x, dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.swiped = performance.now(); this.show(this.index + (dx < 0 ? 1 : -1));
          } else this.sync();
        });
        on(viewport, 'pointercancel', () => { this.start = null; this.sync(); });
        on(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) { this.paused = true; this.show(index); }
        });
        this.sync();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        this.sync();
      }
      sync() {
        clearInterval(this.timer);
        this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
        if (!this.paused && !document.hidden) this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
